/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkHashrateChartPointResponse } from './network-hashrate-chart-point-response';


export interface NetworkHashrateChartResponse { 
    data: Array<NetworkHashrateChartPointResponse>;
}

